import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isPresent } from 'utils/isPresent';
import { getQboLastConnected } from 'components/Quickbooks/Redux/QuickbooksData';
import TrackedButton from 'components/Common/Inputs/Buttons/TrackedButton';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { openConnectToQboDialog } from 'components/Quickbooks/Redux/Actions';
import RedirectTo from 'components/Common/RedirectTo';

const BUTTON_NAME_CONNECT_TO_QBO = 'connect to qbo';

const EnableAppButton = () => {
  const dispatch = useDispatch();

  const quickbooksLastConnected = useSelector(getQboLastConnected);
  const quickbooksEverConnected = isPresent(quickbooksLastConnected);
  const ldClient = useLDClient();

  const openDefaultConnect = () => dispatch(openConnectToQboDialog());
  const openOnboarding = () => RedirectTo.qboOnboarding();

  const addToLDExperimentAndConnect = () => {
    const ldPro = ldClient.getUser();
    const newCustomAttributes = { ...ldPro.custom, quickbooksOnlineEverConnected: quickbooksEverConnected };

    ldClient.identify({ ...ldPro, custom: newCustomAttributes })
      .then(() => openOnboarding())
      .catch(() => openDefaultConnect());
  };

  const onConnectionClick = () => {
    if (quickbooksEverConnected) {
      openDefaultConnect();
    } else {
      addToLDExperimentAndConnect();
    }
  };

  return (
    <TrackedButton
      variant="contained"
      color="primary"
      trackingName={BUTTON_NAME_CONNECT_TO_QBO}
      onClick={onConnectionClick}
    >
      Connect to QuickBooks
    </TrackedButton>
  );
};

export default EnableAppButton;
